import { z } from 'zod';
import { UserRoleSchema } from './permissions.schema.js';
// Audit action types
export const AuditActionSchema = z.enum(['READ', 'UPDATE', 'DELETE']);
// Audit Log Schema
export const AuditLogSchema = z.object({
    auditId: z.string().uuid(),
    timestamp: z.string().datetime(),
    userId: z.string(),
    userEmail: z.string().email(),
    userRole: UserRoleSchema,
    action: AuditActionSchema,
    customerKey: z.string(),
    changedFields: z.array(z.string()).optional(),
    oldValues: z.record(z.any()).optional(),
    newValues: z.record(z.any()).optional(),
    ipAddress: z.string().ip().optional(),
    userAgent: z.string().optional(),
    requestId: z.string(),
});
//# sourceMappingURL=audit.schema.js.map